module.exports = __webpack_public_path__ + "static/img/ikonaNotatnik-OFF.f0ffa78d.png";